// extracted by mini-css-extract-plugin
export var acceptButton = "_1y-5";
export var fullContent = "_1y-4";
export var link = "_1y-6";
export var linkIcon = "_1y-7";
export var sideContent = "_1y-3";
export var sideImage = "_1y-2";
export var sideImageWrapper = "_1y-1";
export var splitLayout = "_1y-0";